import { Play, Pause, ZoomIn, ZoomOut, Crosshair, Gauge, Users, Footprints } from "lucide-react";

export default function CommandBar({ paused, setPaused, speed, setSpeed, onZoomIn, onZoomOut, onRecenter, onCollab, onWalk }) {
  const speeds = [1, 2, 4];
  return (
    <div
      data-testid="command-bar"
      className="fixed bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 z-40 backdrop-blur-2xl bg-[#0f131a]/95 border border-cyan-500/25 rounded-2xl px-2 sm:px-3 py-2 flex items-center gap-1.5 sm:gap-2 shadow-[0_0_30px_rgba(0,240,255,0.15)]"
    >
      <button
        data-testid="simulation-speed-toggle"
        onClick={() => setPaused(!paused)}
        className="w-9 h-9 grid place-items-center rounded-xl bg-white/5 hover:bg-white/10 text-cyan-300 transition-colors"
        title={paused ? "Resume simulation" : "Pause simulation"}
      >
        {paused ? <Play size={16} /> : <Pause size={16} />}
      </button>

      <div className="flex items-center gap-0.5 bg-black/30 rounded-xl p-0.5">
        <Gauge size={13} className="text-zinc-500 mx-1" />
        {speeds.map((s) => (
          <button
            key={s}
            data-testid={`speed-${s}x`}
            onClick={() => setSpeed(s)}
            className={`px-2 h-7 rounded-lg text-xs font-mono font-semibold transition-colors ${
              speed === s ? "bg-cyan-500/20 text-cyan-300" : "text-zinc-500 hover:text-zinc-300"
            }`}
          >
            {s}x
          </button>
        ))}
      </div>

      <div className="w-px h-7 bg-white/10 mx-0.5" />

      <button
        data-testid="collab-trigger"
        onClick={onCollab}
        className="h-9 px-2.5 flex items-center gap-1.5 rounded-xl bg-violet-500/15 hover:bg-violet-500/25 text-violet-300 border border-violet-400/30 transition-colors"
        title="Meeting Room Sync"
      >
        <Users size={16} /> <span className="hidden sm:inline text-xs font-tactical font-bold uppercase tracking-wider">Sync</span>
      </button>

      <button
        data-testid="walk-trigger"
        onClick={onWalk}
        className="h-9 px-2.5 flex items-center gap-1.5 rounded-xl bg-emerald-500/15 hover:bg-emerald-500/25 text-emerald-300 border border-emerald-400/30 transition-colors"
        title="Walk through your HQ"
      >
        <Footprints size={16} /> <span className="hidden sm:inline text-xs font-tactical font-bold uppercase tracking-wider">Walk</span>
      </button>

      <div className="hidden sm:flex items-center gap-1.5">
      <div className="w-px h-7 bg-white/10 mx-0.5" />

      <button data-testid="zoom-out-button" onClick={onZoomOut} className="w-9 h-9 grid place-items-center rounded-xl bg-white/5 hover:bg-white/10 text-zinc-300 transition-colors">
        <ZoomOut size={16} />
      </button>
      <button data-testid="recenter-view-button" onClick={onRecenter} className="w-9 h-9 grid place-items-center rounded-xl bg-white/5 hover:bg-white/10 text-zinc-300 transition-colors" title="Re-center orbit">
        <Crosshair size={16} />
      </button>
      <button data-testid="zoom-in-button" onClick={onZoomIn} className="w-9 h-9 grid place-items-center rounded-xl bg-white/5 hover:bg-white/10 text-zinc-300 transition-colors">
        <ZoomIn size={16} />
      </button>
      </div>
    </div>
  );
}
